/**
 * Verifica se um valor representa um número inteiro.
 * Permite sinais de positivo (+) e negativo (-)
 * @param {*} valor Valor a ser verificado
 * @returns {Boolean} Retorna verdadeiro se o valor for um número inteiro
 */
function validarInteiro(valor) {
    //Verifica se o valor foi informado
    if (valor === null || valor === undefined)
        return false;
    //Expressão regular para validação
    const regex = /^[-+]?\d*$/g;
    //Verifica se o valor é válido
    return regex.test(valor.toString().trim());
}

/**
 * Verifica se um valor, pode ser uma string ou um número, representa um número decimal
 * Permite sinais de positivo (+) e negativo (-) e separador de decimal com vírgula ou ponto
 * @param {*} valor Valor a ser verificado
 * @returns {Boolean} Retorna verdadeiro se o valor for um número decimal
 */
function validarDecimal(valor) {
    //Verifica se o valor foi informado
    if (valor === null || valor === undefined)
        return false;
    //Expressão regular para validação
    const regex = /^[-+]?\d*[,.]?\d*$/g;
    let stringValue = valor.toString().trim();
    //Verifica se o valor é válido
    return regex.test(stringValue);
}

/**
 * Converte um valor para número.
 * Caso não seja um valor válido, retorna NaN
 * @param {*} valor Valor a ser convertido
 * @returns {Number} Retorna um número ou NaN, caso não seja possível realizar a conversão
 */
function converterNumero(valor) {
    //Verifica se o valor foi informado
    if (valor === null || valor === undefined)
        return null;
    //Multipla por 1 para transformar em número
    return valor.toString().replace(',', '.') * 1;
}

/**
 * Formata um número com separador de milher e três casas decimais
 * @param {Number} valor Número a ser formatado
 * @returns {String} Retorna o número formatado, com casas decimais e separador de milhar
 */
function formatarNumero(valor) {
    if (typeof valor !== 'number' || isNaN(valor))
        return '';
    else 
        return valor
            .toFixed(3) //Formata com três casas decimais
            .replace('.', ',') //Utiliza a vírgula como separador decimal
            .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.'); //Utiliza o ponto como separador de milhar
}

export { validarInteiro, validarDecimal, converterNumero, formatarNumero };